import { Box, Button, Divider, Grid, Link, Tooltip, Typography } from '@mui/material';
import { palette } from '../palette';
import { Google } from '@mui/icons-material';
import { colors } from '@mui/material';
import React, { PropsWithChildren } from 'react';

interface LoginButtonProps extends PropsWithChildren {
  onLoginClicked?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  authenticationRedirectUrl?: string;
  loginButtonHelp: string | React.ReactElement;
}

export function LoginButton({ children, loginButtonHelp, onLoginClicked, disabled = false }: LoginButtonProps) {
  const authUrl = (import.meta.env.VITE_APP_BASE_SERVER_URL || 'http://localhost:3000') + '/auth';
  return (
    <>
      <Box height={'100vh'} display={'flex'} flexDirection={'column'} flex={'auto'} justifyContent={'space-around'}>
        <Grid display={'flex'} flexDirection={'row'} justifyContent={'center'}>
          <img alt="We Hate Exercise" width={'200px'} src={'./logo.png'}></img>
        </Grid>

        <Grid display={'flex'} flexDirection={'column'} justifyContent={'flex-end'}>
          {disabled && (
            <Tooltip title={loginButtonHelp} arrow placement={'top'}>
              <span>
                <Button disabled>
                  <Grid
                    borderRadius={1}
                    padding={1}
                    display={'flex'}
                    flexDirection={'row'}
                    justifyContent={'space-evenly'}
                    bgcolor={palette.secondary.dark}
                  >
                    <Google sx={{ height: '1.2em', color: colors.common.white }}></Google>
                    <Typography variant={'button'} color={palette.secondary.light} padding={'4px'}>
                      Sign In with Google
                    </Typography>
                  </Grid>
                </Button>
              </span>
            </Tooltip>
          )}
          {!disabled && (
            <>
              <Tooltip title={loginButtonHelp} arrow placement={'top'}>
                <Button fullWidth color={'inherit'} href={authUrl} onClick={onLoginClicked}>
                  <Grid
                    borderRadius={1}
                    padding={1}
                    display={'flex'}
                    flexDirection={'row'}
                    justifyContent={'space-evenly'}
                    bgcolor={palette.primary.main}
                  >
                    <Google sx={{ height: '1.2em', color: colors.common.white }}></Google>
                    <Typography variant={'button'} color={palette.secondary.contrastText} padding={'4px'}>
                      Sign In with Google
                    </Typography>
                  </Grid>
                </Button>
              </Tooltip>
            </>
          )}
        </Grid>
        {children}
      </Box>
    </>
  );
}
